// TODO: add test for regex
const regex = /[a-zA-Z0-9]{8}-[a-zA-Z0-9]{4}-[a-zA-Z0-9]{4}-[a-zA-Z0-9]{4}-[a-zA-Z0-9]{12}/;

export const getFileGuidFromUrl = (url: string): string | undefined => {
  const matchResult = regex.exec(url);
  if (matchResult === null) return undefined;
  if (matchResult.length < 1) return undefined;
  return matchResult[0];
};
